import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { pastorApi } from '../pastorApi';
import { usePastorMe } from '../usePastorMe';

// 담임목사청빙지원 > 서비스소개 — 사역자모아가 가운데서 목사님과 교회를 잇는다
export default function PastorLanding() {
  const navigate = useNavigate();
  const { isLogin, isChurch, me } = usePastorMe();
  const [stats, setStats] = useState<{ pastors: number; ruralOpen: number; requests: number; delivered: number } | null>(null);

  useEffect(() => {
    pastorApi.stats().then(setStats).catch(() => setStats(null));
  }, []);

  const go = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <div className="pastor-call pc-landing">
      <section className="pc-hero">
        <div className="inner">
          <p className="mm-eyebrow">담임목사 청빙 중개</p>
          <h1 className="pc-hero__title">
            담임목사를 찾는 교회와 담임목회를 꿈꾸는 목사님,<br />
            <em>사역자모아가 가운데서 잇습니다.</em>
          </h1>
          <p className="pc-hero__sub">
            목사님은 이력서를 사역자모아에 맡겨 두세요. 맞는 교회가 있으면 먼저 여쭙고, 동의하신 교회에만 전달합니다.<br />
            교회는 청빙 의뢰서 한 장이면 됩니다. 맞는 목사님을 찾아 이력서를 보내 드리고, 청빙 소식을 목사님들께 알려 드립니다.
          </p>

          <div className="pc-tracks">
            <div className="pc-track">
              <p className="pc-track__who">담임목회를 희망하시는 목사님</p>
              <p className="pc-track__desc">현재 사역지에 알려질 걱정 없이 이력서를 맡기세요. 지방·농어촌 교회의 청빙 소식까지 받아 보실 수 있습니다.</p>
              <button type="button" className="mm-btn mm-btn--primary pc-btn-lg mm-btn--block" onClick={() => go('/pastor/profile')}>
                {me?.pastorProfile ? '내 이력서 관리' : '사역자모아에 이력서 맡기기'}
              </button>
              <button type="button" className="mm-btn--ghost pc-track__link" onClick={() => go(me?.pastorProfile ? '/pastor/my' : '/pastor/jobs')}>
                {me?.pastorProfile ? '내 청빙 소식 보기 →' : '담임목사 청빙 소식 보기 →'}
              </button>
            </div>
            <div className="pc-track pc-track--church">
              <p className="pc-track__who">담임목사님을 찾는 교회</p>
              <p className="pc-track__desc">공고를 올리고 기다리지 않으셔도 됩니다. 교회 형편을 알려 주시면 사역자모아가 맞는 목사님을 찾아 이력서를 전달해 드립니다.</p>
              <button type="button" className="mm-btn mm-btn--primary pc-btn-lg mm-btn--block" onClick={() => go('/pastor/request')}>
                담임목사 청빙 의뢰하기
              </button>
              <button type="button" className="mm-btn--ghost pc-track__link" onClick={() => go(isLogin && isChurch ? '/pastor/my' : '/recruit/recruitministerpost')}>
                {isLogin && isChurch ? '내 청빙 현황 보기 →' : '구인정보에 담임목사 공고 올리기 →'}
              </button>
            </div>
          </div>

          {stats && stats.pastors > 0 && (
            <dl className="pc-stats">
              <div><dt>이력서를 맡긴 목사님</dt><dd>{stats.pastors.toLocaleString()}명</dd></div>
              <div><dt>지방·농어촌 사역 가능</dt><dd>{stats.ruralOpen.toLocaleString()}명</dd></div>
              <div><dt>교회에 전달한 이력서</dt><dd>{stats.delivered.toLocaleString()}건</dd></div>
            </dl>
          )}
        </div>
      </section>

      <section className="inner pc-sect">
        <div className="mm-sect"><h2>이렇게 진행됩니다</h2></div>
        <ol className="pc-flow">
          <li>
            <b>01</b>
            <p className="pc-flow__title">목사님 · 이력서 맡기기</p>
            <p>목회 철학과 소명, 희망 지역과 필요 조건(사택·연금 등)을 적어 사역자모아에 맡깁니다. 교회는 이 이력서를 직접 볼 수 없습니다.</p>
          </li>
          <li>
            <b>02</b>
            <p className="pc-flow__title">교회 · 청빙 의뢰</p>
            <p>청빙 의뢰서를 보내거나 구인정보에 담임목사 공고를 올립니다. 인터넷이 어려우면 전화·카카오톡으로도 됩니다.</p>
          </li>
          <li>
            <b>03</b>
            <p className="pc-flow__title">사역자모아 · 맞는 분께 먼저 여쭙기</p>
            <p>교단·지역·교회 형편이 맞는 목사님을 골라 "이 교회에 이력서를 보내도 될까요?" 하고 먼저 여쭙니다.</p>
          </li>
          <li>
            <b>04</b>
            <p className="pc-flow__title">동의하시면 이력서 전달</p>
            <p>목사님이 동의하신 교회에만 이력서와 연락처가 전달됩니다. 담임목사 청빙 소식은 등록 목사님들께 따로 알려 드립니다.</p>
          </li>
        </ol>
      </section>

      <section className="inner pc-sect">
        <div className="mm-sect"><h2>목사님의 신원은 이렇게 지켜집니다</h2></div>
        <ul className="pc-safe">
          <li><b>교회는 직접 볼 수 없음</b><span>맡기신 이력서는 사역자모아만 봅니다. 목록으로 공개되거나 검색되지 않습니다.</span></li>
          <li><b>동의한 교회에만 전달</b><span>추천할 교회가 있으면 먼저 여쭙고, 동의하신 교회 한 곳에만 전달합니다.</span></li>
          <li><b>사양해도 비밀 유지</b><span>사양하시면 교회는 누구에게 연락이 갔는지조차 알 수 없습니다.</span></li>
          <li><b>제외할 교회 지정</b><span>현재 섬기는 교회나 소속 노회의 교회를 적어 두면 그 교회에는 추천하지 않습니다.</span></li>
          <li><b>언제든 멈추기</b><span>버튼 하나로 추천을 멈추거나 이력서를 완전히 삭제할 수 있습니다.</span></li>
        </ul>
      </section>

      <section className="inner pc-sect pc-sect--last">
        <div className="pc-banner">
          <div>
            <p className="pc-banner__title">인터넷이 익숙지 않으셔도 괜찮습니다</p>
            <p>전화나 카카오톡으로 교회 사정을 말씀해 주시면 사역자모아가 의뢰서를 대신 작성하고 목사님을 찾아 드립니다.</p>
          </div>
          <p className="pc-banner__hint">오른쪽 아래 <b>[청빙 대행 상담]</b> 버튼을 눌러 주세요</p>
        </div>
      </section>
    </div>
  );
}
